<h1 class="text-center">Založení případu pro více listů vlastnictví</h1>

<p class="font-size-16 mb-10">{{ subjectName }} je uvedený(á) v dalších LV, které vyhovují vybranému typu případu {{ obligationName }}</p>
<p class="font-size-16">Přejete si do zakládaného případu zahrnout další listy vlastnictví?</p>
<div class="text-center">
  <gmt-button [clickAction]="onSubmit" class="pr-15">Ano</gmt-button>
  <gmt-button [clickAction]="onCancel" class="red">Ne</gmt-button>
</div>
